import { render, staticRenderFns } from "./UsersReport.vue?vue&type=template&id=1b6f8294"
import script from "./UsersReport.vue?vue&type=script&lang=js"
export * from "./UsersReport.vue?vue&type=script&lang=js"
import style0 from "./UsersReport.vue?vue&type=style&index=0&id=1b6f8294&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports